import { render } from "./VideoElement.vue?vue&type=template&id=adadb03c&scoped=true"
import script from "./VideoElement.vue?vue&type=script&lang=js"
export * from "./VideoElement.vue?vue&type=script&lang=js"

import "./VideoElement.vue?vue&type=style&index=0&id=adadb03c&scoped=true&lang=scss"
import "./VideoElement.vue?vue&type=style&index=1&id=adadb03c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adadb03c"]])

export default __exports__